import { render, staticRenderFns } from "./NodeFooter.vue?vue&type=template&id=b17683a8"
import script from "./NodeFooter.vue?vue&type=script&lang=js"
export * from "./NodeFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports